/* Число голосов каталога, которое публикует сервер (catalog_total сессии и страниц каталога без отбора по переозвучке):
   подпись «… · ещё N+ голосов» у пилла голоса экрана на движке шаблона (voice-server.ts, voiceTotal). Ставит его server-state.ts
   там же, где BotDemo.VTOTAL оболочки; без числа сервера — 0, и подписи нет (запасное число оболочки сюда не попадает). */
let total = 0;

export function catalogTotal(): number {
  return total;
}

export function setCatalogTotal(value: unknown) {
  total = typeof value === 'number' && Number.isSafeInteger(value) && value > 0 ? value : 0;
}
